var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocalizaoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 2.336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0A7,7,0,0,0,0,7,12.729,12.729,0,0,0,.58,9.81l.02.02a7.76,7.76,0,0,0,.99,1.78l4.652,7.315A.869.869,0,0,0,7.7,18.93l4.805-7.46a12,12,0,0,0,.79-1.45l.02-.05A6.887,6.887,0,0,0,14,7,7,7,0,0,0,7,0M7,10.5A3.5,3.5,0,1,1,10.5,7,3.5,3.5,0,0,1,7,10.5",
    fill: "#eee"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalizaoWhite);
export default __webpack_public_path__ + "static/media/localização - white.6ec301795ef773114d49a9e48dc26cf7.svg";
export { ForwardRef as ReactComponent };